import { useGetWorldCheckCountries } from "../../api/country";

export const useMetadataCountries = () => {
  const { data = { data: [] }, isLoading } = useGetWorldCheckCountries();
  const metadataCountries = data.data.map(
    (item: { value: string; label: string }) => {
      return {
        value: item.label,
        label: item.label,
      };
    }
  );
  return { metadataCountries, isLoading };
};
